import appSettings from "../settings/appSettings";
import fetchRequest from "./fetchRequest";
import { wvusLogger } from "../helpers";

export async function requestEletter({
  childId,
  countryCode,
  orderRef,
  cssc,
  orderHandshake,
  mediaUrl,
  mediaHandshake,
  sponsorName,
  childName
}) {
  const { eventsServiceConfig, eletterMessage } = appSettings;
  const { baseUrl, apiKey } = eventsServiceConfig;
  const queryParams = [
    ["handshake", encodeURIComponent(orderHandshake)],
    ["identifier", encodeURIComponent(orderRef)],
    ["marker", encodeURIComponent(cssc)]
  ]
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  const url = `${baseUrl}/eletters?${queryParams}`;
  const letterText = eletterMessage
    .replace(/\[sponsor name\]/g, sponsorName)
    .replace(/\[child name\]/g, childName);

  const apiPayload = {
    childNumber: `${countryCode}-${childId}`,
    countryCode: countryCode,
    orderReferenceNumber: orderRef,
    campaignSourceCode: cssc,
    handshake: orderHandshake,
    eventSubject: "accordion/sendLetter",
    letterText: letterText,
    mediaUrl1: mediaUrl,
    mediaHandshake1: mediaHandshake
  };

  // Log Request
  wvusLogger.log(
    JSON.stringify({
      dscription: "Sending eletter request to events service",
      url,
      apiPayload
    }),
    wvusLogger.getLogLevelNames().INFO
  );

  try {
    const response = await fetchRequest(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "ocp-apim-subscription-key": apiKey
      },
      body: JSON.stringify(apiPayload),
      cache: "no-cache",
      mode: "cors",
      timeout: 15 * 1000
    });

    if (!response.ok) {
      // TODO: Include Better parsing of error message from response
      throw new Error("Failed to send eletter");
    }

    const respData = await response.json();

    if (!respData || !respData.letterId) {
      // TODO: Include Better parsing of error message from response
      throw new Error("Invalid eletter response");
    }

    return respData;
  } catch (err) {
    wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
    console.error(err);
    return Promise.reject(err);
  }
}
